// Background options with display information
export const backgroundOptions = {
  white: { class: "bg-white", label: "White" },

  // Soft gradients
  gradient1: {
    class: "bg-gradient-to-r from-purple-100 to-indigo-100",
    label: "Purple Mist",
  },
  gradient2: {
    class: "bg-gradient-to-r from-amber-50 to-rose-100",
    label: "Warm Sunset",
  },
  gradient3: {
    class: "bg-gradient-to-r from-teal-50 to-cyan-100",
    label: "Ocean Breeze",
  },
  gradientMint: {
    class: "bg-gradient-to-br from-green-50 to-emerald-100",
    label: "Mint Fresh",
  },
  gradientLavender: {
    class: "bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50",
    label: "Lavender",
  },
  gradientPeach: {
    class: "bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50",
    label: "Peach Glow",
  },

  // Vibrant gradients
  gradientPurple: {
    class:
      "bg-gradient-to-br from-purple-400 via-pink-400 to-indigo-500",
    label: "Purple Burst",
  },
  gradientOrange: {
    class:
      "bg-gradient-to-br from-orange-400 via-red-400 to-pink-500",
    label: "Fire Glow",
  },
  gradientTeal: {
    class:
      "bg-gradient-to-br from-teal-400 via-cyan-400 to-blue-500",
    label: "Ocean Deep",
  },
  gradientBlue: {
    class:
      "bg-gradient-to-br from-blue-400 via-purple-400 to-indigo-600",
    label: "Night Sky",
  },
  gradientSunset: {
    class:
      "bg-gradient-to-br from-orange-500 via-pink-500 to-purple-600",
    label: "Sunset",
  },
  gradientForest: {
    class:
      "bg-gradient-to-br from-green-600 via-emerald-500 to-teal-400",
    label: "Forest",
  },

  // Dark themes
  dark: {
    class: "bg-gray-900",
    label: "Dark",
  },
  darkPurple: {
    class:
      "bg-gradient-to-br from-purple-900 via-indigo-900 to-blue-900",
    label: "Dark Purple",
  },
  cyber: {
    class:
      "bg-gradient-to-br from-gray-900 via-purple-900 to-black",
    label: "Cyber",
  },
  midnight: {
    class:
      "bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900",
    label: "Midnight",
  },

  // Textured backgrounds
  paper: {
    class: "bg-gradient-to-br from-amber-50 to-orange-50",
    label: "Paper",
  },
  parchment: {
    class: "bg-gradient-to-br from-yellow-50 to-amber-100",
    label: "Parchment",
  },
  vintage: {
    class:
      "bg-gradient-to-br from-amber-50 to-orange-100 border border-amber-200",
    label: "Vintage",
  },

  // Creative patterns
  // dots: {
  //   class:
  //     "bg-white bg-[radial-gradient(circle_at_2px_2px,rgba(0,0,0,.1)_1px,transparent_0)] bg-[length:20px_20px]",
  //   label: "Dots",
  // },
  // lines: {
  //   class:
  //     "bg-white bg-[linear-gradient(90deg,rgba(0,0,0,.1)_1px,transparent_1px)] bg-[length:20px_20px]",
  //   label: "Lines",
  // },
  // grid: {
  //   class:
  //     "bg-white bg-[linear-gradient(rgba(0,0,0,.1)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,.1)_1px,transparent_1px)] bg-[length:20px_20px]",
  //   label: "Grid",
  // },

  // Minimal themes
  cream: {
    class: "bg-gradient-to-br from-stone-50 to-amber-50",
    label: "Cream",
  },
  pearl: {
    class: "bg-gradient-to-br from-gray-50 to-slate-100",
    label: "Pearl",
  },
  mist: {
    class: "bg-gradient-to-br from-blue-50 to-indigo-50",
    label: "Mist",
  },
  blush: {
    class: "bg-gradient-to-br from-pink-50 to-rose-100",
    label: "Blush",
  },
  sage: {
    class: "bg-gradient-to-br from-green-50 to-emerald-100",
    label: "Sage",
  },
};

// Curated production-ready font selection
export const fontOptions = [
  { name: "Georgia", class: "font-georgia" }, // Best for long reading
  { name: "Times New Roman", class: "font-times" }, // Universal standard
  { name: "Arial", class: "font-arial" }, // Most compatible sans-serif
  { name: "Helvetica", class: "font-helvetica" }, // Professional sans-serif
  { name: "Verdana", class: "font-verdana" }, // Optimized for screens
  { name: "Trebuchet MS", class: "font-trebuchet" }, // Modern and readable
  // { name: "Courier New", class: "font-courier" }, 
  { name: "Palatino", class: "font-palatino" }, 
  { name: "Sans Serif", class: "font-sans" },
];

// Helper functions
export const applyTextFormatting = (content, start, end, format) => {
  const selectedText = content.substring(start, end);
  let formattedText = "";
  let cursorPosition = 0;

  switch (format) {
    case "bold":
      formattedText =
        content.substring(0, start) +
        `**${selectedText}**` +
        content.substring(end);
      cursorPosition = selectedText ? end + 4 : start + 4;
      break;
    case "italic":
      formattedText =
        content.substring(0, start) +
        `*${selectedText}*` +
        content.substring(end);
      cursorPosition = selectedText ? end + 2 : start + 2;
      break;
    case "underline":
      formattedText =
        content.substring(0, start) +
        `__${selectedText}__` +
        content.substring(end);
      cursorPosition = selectedText ? end + 4 : start + 4;
      break;
    case "heading":
      formattedText =
        content.substring(0, start) +
        `# ${selectedText}` +
        content.substring(end);
      cursorPosition = selectedText ? end + 2 : start + 2;
      break;
    case "quote":
      formattedText =
        content.substring(0, start) +
        `> ${selectedText}` +
        content.substring(end);
      cursorPosition = selectedText ? end + 2 : start + 2;
      break;
    case "list":
      formattedText =
        content.substring(0, start) +
        `- ${selectedText}` +
        content.substring(end);
      cursorPosition = selectedText ? end + 2 : start + 2;
      break;
    case "orderedList":
      formattedText =
        content.substring(0, start) +
        `1. ${selectedText}` +
        content.substring(end);
      cursorPosition = selectedText ? end + 3 : start + 3;
      break;
    default:
      return { formattedText: content, cursorPosition: start };
  }

  return { formattedText, cursorPosition };
};